'use client';

import { useContext } from 'react';

import {
  WalletConnectionModalContext,
  type WalletConnectionModalContextValue,
} from '@/components/Auth/WalletConnectionModalProvider';

/**
 * Access the wallet-connection entrypoint from {@link WalletConnectionModalProvider}.
 * Throws if used outside the provider so a missing-provider mistake fails loudly
 * at the call site rather than silently no-op'ing a connect click.
 */
export function useWalletConnectionModal(): WalletConnectionModalContextValue {
  const context = useContext(WalletConnectionModalContext);
  if (context === undefined) {
    throw new Error('useWalletConnectionModal must be used within <WalletConnectionModalProvider>');
  }
  return context;
}
